export default __webpack_public_path__ + "static/media/computer.6a406e2e.jpg";